"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var mobx_react_1 = require("mobx-react");

var shared_1 = require("../../../../../shared");

var Head_meta_1 = require("./Head.meta");

var TableComponentBase_1 = require("../TableComponentBase");

var HeadRow_1 = __importDefault(require("../HeadRow"));

var Head =
/** @class */
function (_super) {
  __extends(Head, _super);

  function Head(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = Head_meta_1.HEAD_CATEGORY_KEY;
    _this.componentKey = Head_meta_1.HEAD_COMPONENT_KEY;
    return _this;
  }

  Object.defineProperty(Head.prototype, "parentComponentKey", {
    get: function get() {
      return Head_meta_1.HEAD_PARENT_COMPONENT_KEY;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Head.prototype, "tableEventsKey", {
    get: function get() {
      return 'head';
    },
    enumerable: true,
    configurable: true
  });

  Head.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        children = _a.children,
        configuration = _a.configuration,
        componentStyle = _a.componentStyle,
        componentStyleProps = _a.componentStyleProps,
        table = _a.table,
        _b = _a.headerRows,
        headerRows = _b === void 0 ? [] : _b,
        otherProps = __rest(_a, ["children", "configuration", "componentStyle", "componentStyleProps", "table", "headerRows"]);

    var events = this.getEvents(this.eventsForElement);
    return react_1.default.createElement("thead", __assign({}, events, otherProps), headerRows.map(function (headerRow, headerRowIndex) {
      return react_1.default.createElement(HeadRow_1.default, {
        key: _this.getHeadRowKey(headerRowIndex),
        table: _this.table,
        headerRow: headerRow,
        rowIndex: headerRowIndex
      });
    }));
  };

  Head = __decorate([mobx_react_1.observer], Head);
  return Head;
}(TableComponentBase_1.TableComponentBase);

exports.Head = Head;
exports.default = shared_1.InjectedStyledComponent(Head, Head_meta_1.HEAD_CATEGORY_KEY, Head_meta_1.HEAD_PARENT_COMPONENT_KEY, [Head_meta_1.HEAD_COMPONENT_KEY]);